import *  as yup from 'yup';

export const validationSchema = yup.object({
    firstName: yup
        .string('First name')
        .required("First name is required"),
    lastName: yup
        .string('Last name')
        .required("Last name is required"),
    mobile: yup
        .string('Phone')
        .phone("CA", "Plese enter a valid phone number")
        .required("At least one phone is required"),
    birthdate: yup
    .date(),
    sex: yup
    .string()
});